import React, { useState, useEffect } from "react";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faWarehouse,
  faRulerHorizontal,
  faRulerVertical,
  faTimes,
  faPlus,
  faSeedling,
} from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../../../context/AuthContext";
import { useShoppingContext } from "../../../../context/ShoppingContext";
import "./AddGalponForm.css"; // Importa el archivo CSS

const AddGalponForm = () => {
  const {
    fetchMisGalpones,
    setShowAddGalpon,
    granjas,
    setLoading,
    setSelectedGalpon,
    setShowFarmer, // Ocultar FarmerMessage
    setGalponCreatedFromAveForm, // Reiniciar el estado después de la creación
  } = useShoppingContext();
  const { authenticatedUser } = useAuth();

  const [formData, setFormData] = useState({
    nombre: "",
    largo: "",
    ancho: "",
    granjaId: "", // Will be set to last granja
    userId: authenticatedUser.id,
  });

  // Find the last granja for the authenticated user
  useEffect(() => {
    const userGranjas = granjas.filter(
      (granja) => granja.userId === authenticatedUser.id
    );
    if (userGranjas.length > 0) {
      const lastGranja = userGranjas[userGranjas.length - 1];
      setFormData((prevData) => ({
        ...prevData,
        granjaId: lastGranja.id, // Set last granja as default
      }));
    }
  }, [granjas, authenticatedUser.id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    setShowAddGalpon(false); // Cierra el formulario
    setLoading("creando galpón");

    axios
      .post(`${process.env.REACT_APP_API_URL}/galpones`, formData)
      .then((response) => {
        console.log("Galpón creado", response.data);
        const createdGalpon = response.data.galpon; // Captura el galpón creado
        fetchMisGalpones(); // Refrescar la lista de galpones
        setSelectedGalpon(createdGalpon.id); // Seleccionar el galpón recién creado
        setLoading(false);

        // Si venimos desde el AddAveForm, ocultamos el FarmerMessage y continuamos
        setShowFarmer(false);
        setGalponCreatedFromAveForm(false); // Reinicia el estado
      })
      .catch((error) => {
        console.error("Error al agregar el galpón:", error);
        setLoading(false);
      });
  };

  return (
    <div className="add-form-container">
      <form onSubmit={handleSubmit} className="add-ave-form">
        <h2 className="add-galpon-form-title">
          <FontAwesomeIcon icon={faWarehouse} /> Crear nuevo Galpón
        </h2>

        <div className="">
          <label htmlFor="nombre" className="add-galpon-form-label">
            Nombre del Galpón
          </label>
          <input
            type="text"
            id="nombre"
            name="nombre"
            value={formData.nombre}
            onChange={handleChange}
            className="add-galpon-form-input"
            required
          />
        </div>
        <div className="flex-space-between">
          <div className="">
            <label htmlFor="largo" className="add-galpon-form-label">
              <FontAwesomeIcon icon={faRulerVertical} /> Largo (Mts.)
            </label>
            <input
              type="number"
              id="largo"
              name="largo"
              value={formData.largo}
              onChange={handleChange}
              className="add-galpon-form-input"
              inputMode="numeric"
              required
            />
          </div>
          <div className="">
            <label htmlFor="ancho" className="add-galpon-form-label">
              <FontAwesomeIcon icon={faRulerHorizontal} /> Ancho (Mts.)
            </label>
            <input
              type="number"
              id="ancho"
              name="ancho"
              value={formData.ancho}
              onChange={handleChange}
              className="add-galpon-form-input"
              inputMode="numeric"
              required
            />
          </div>
        </div>

        <div className="add-ave-form-group">
          <label htmlFor="granjaId" className="add-galpon-form-label">
            <FontAwesomeIcon icon={faSeedling} /> Granja a la que pertenece
          </label>
          <select
            id="granjaId"
            name="granjaId"
            value={formData.granjaId}
            onChange={handleChange}
            className="add-galpon-form-input btn btn-green-outline"
            required
          >
            <option value="">Seleccione una granja</option>
            {granjas.map((granja) => (
              <option key={granja.id} value={granja.id}>
                {granja.nombre}
              </option>
            ))}
          </select>
        </div>
        <div className="add-ave-form-buttons">
          <button
            type="button"
            onClick={() => setShowAddGalpon(false)}
            className="btn btn-green-outline"
          >
            <FontAwesomeIcon icon={faTimes} /> Cancelar
          </button>
          <button type="submit" className="submit btn btn-green">
            <FontAwesomeIcon icon={faPlus} /> Agregar
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddGalponForm;
